import { ArrowRightIcon, PlayCircleIcon } from "@heroicons/react/24/solid";
import { ReactNode } from "react";
import Button from "../../componentLibrary/Button";
import { LessonI } from "../../types";
import VideoComponent from "../CreateLessonPage/components/contentComponents/VideoComponent";

type TopicTrailerProps = {
  header: ReactNode;
  trailerVideoUrl?: string;
  trailerTranscript?: string;
  topicTocEnabled: boolean;
  firstLesson?: LessonI;
  continueLesson?: LessonI;
  onClickLesson: (lessonId: string) => void;
};

const TopicTrailer = ({
  header,
  trailerVideoUrl,
  trailerTranscript,
  topicTocEnabled,
  firstLesson,
  continueLesson,
  onClickLesson,
}: TopicTrailerProps) => {
  const trailerVideo = trailerVideoUrl?.trim() ? (
    <VideoComponent
      url={trailerVideoUrl.trim()}
      transcript={trailerTranscript}
      fitInContainer
    />
  ) : null;

  const trailerCTAs =
    topicTocEnabled && firstLesson?._id ? (
      <div className="flex flex-col sm:flex-row gap-3 mt-4 w-full max-w-full overflow-hidden">
        {continueLesson && (
          <Button
            variant="dark"
            roundedFull
            className="w-full sm:flex-1 min-w-0 overflow-hidden"
            onClick={() => onClickLesson(continueLesson._id)}
          >
            <span className="truncate">Continue: {continueLesson.title}</span>
          </Button>
        )}
        <Button
          variant={continueLesson ? "secondary" : "dark"}
          roundedFull
          className="w-full sm:flex-1 min-w-0 overflow-hidden"
          onClick={() => onClickLesson(firstLesson._id)}
        >
          <span className="truncate">
            {continueLesson ? "Restart" : "Start"}: {firstLesson.title}
          </span>
        </Button>
      </div>
    ) : null;

  return (
    <>
      {trailerVideo && (
        <div className="order-first w-full mb-4 lg:order-last lg:mb-0 lg:mt-4">
          {trailerVideo}
          {trailerCTAs && <div className="hidden lg:block">{trailerCTAs}</div>}
        </div>
      )}
      <div
        className={trailerVideo ? "order-last w-full lg:order-first" : "w-full"}
      >
        {header}
        {trailerCTAs && <div className="lg:hidden mt-4">{trailerCTAs}</div>}
      </div>
    </>
  );
};

export default TopicTrailer;
